export default __webpack_public_path__ + "static/media/anni-lucky-draw.416e5461.webp";